import React, {useEffect, useState} from 'react';
import {Col, Container, OverlayTrigger, Row, Tooltip} from "react-bootstrap";
import moment from "moment";
import {getSentNotifications, hideSender} from "../../../services/notifications";
import {useHistory} from "react-router-dom";
import {MdDelete} from "react-icons/all";
import ScaleLoader from "react-spinners/ScaleLoader";
import {useTranslation} from "react-i18next";

// React Components
import Header from "../../../components/Header";
import Notification from "../../../components/Notification/Notification";

// CSS Files
import './styles.css';

const override = `
    display: block;
    text-align: center;
    margin-top: 10%;
`;

const SentNotifications = (props) => {
   const [notifications, setNotifications] = useState([]);
   const [selectedNotifications, setselectedNotifications] = useState([])
   const [loading, setLoading] = useState(true);
   const history = useHistory();
   const { t } = useTranslation();

   useEffect(() => {
      (async () => {
         let notifications = await getSentNotifications();
         setNotifications(notifications);
         setLoading(false);
      })()
   }, []);

   return <div className={"SentNotifications"}>
      <Header headerBarTitle={t("sent_messages_page.header")} headerButtonRight="" showHeaderExtras showBackButton/>

      <Container className={"desktop"}>
         <Row>
            <Col xs={12}>
               <ScaleLoader
                   css={override}
                   sizeUnit={"px"}
                   size={30}
                   color={'#afff55'}
                   loading={loading}
               />

               {!loading && notifications.length === 0 &&
                   <div className="alert alert-info" role="alert">
                      {t("sent_messages_page.no_sent_messages")}
                   </div>
               }
            </Col>
         </Row>

         <Row className={"justify-content-end"}>
            <Col xs={12} className={"pb-3 text-right"}>
               {selectedNotifications.length !== 0 &&
                   <OverlayTrigger
                       placement={'bottom'}
                       delay={{show: 250, hide: 400}}
                       overlay={
                          <Tooltip id="button-tooltip">
                             {t("inbox_page.delete_selected_messages")}
                          </Tooltip>
                       }
                       placeHolder={"asdsa"}
                   >
                      <MdDelete
                          size={24}
                          onClick={async () => {
                             for (const id of selectedNotifications) {
                                await hideSender(id);
                             }

                             let notifications = await getSentNotifications();
                             setNotifications(notifications);
                          }}
                          className={"icon"}
                      />
                   </OverlayTrigger>
               }
            </Col>
         </Row>

         {notifications.map((notification, key) => {
            const div = document.createElement('div');
            div.innerHTML = notification.body;

            return (
                <Row key={key}>
                   <Col xs={12}>
                      <Notification
                          id={notification.id}
                          title={notification.title}
                          date={moment(notification.date).utc().format('DD/MM/YYYY')}
                          body={`${div.innerText.substring(0, 150)}...`}
                          read={notification.read}
                          archived={notification.archived}
                          onClick={() => history.push(`/notifications/${notification.id}`, {from: history.location.pathname})}
                          onChangeCheckBox={(e) => {
                             if (e.target.checked) {
                                setselectedNotifications([...selectedNotifications, parseInt(e.target.value)])
                             } else {
                                setselectedNotifications(selectedNotifications.filter((id) => id !== parseInt(e.target.value)))
                             }
                          }}
                          checkboxChecked={selectedNotifications.includes(notification.id)}
                      />
                   </Col>
                </Row>
            );
         })}
      </Container>
   </div>
};

export default SentNotifications;